import { RootState } from "../../../rootReducer";

export const selectIsLoading = (state: RootState) => state.createVenues.loading;
export const selectErrorMessage = (state: RootState) =>
  state.createVenues.error;
export const createVenuesResponse = (state: RootState) =>
  state.createVenues.createVenuesResponse;
